"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUsableAddressComponentsFromPlaceDetails = void 0;
const getUsableAddressComponentsFromPlaceDetails = (placeDetails) => {
    const { name, address_components } = placeDetails;
    const streetNumber = address_components?.find((component) => component.types.includes('street_number'))?.long_name;
    const streetName = address_components?.find((component) => component.types.includes('route'))?.long_name;
    const addressArray = [];
    if (streetNumber) {
        addressArray.push(streetNumber);
    }
    if (streetName) {
        addressArray.push(streetName);
    }
    const addressString = addressArray.join(' ');
    const address_first = addressString.length ? addressString : undefined;
    const address_city = address_components?.find((component) => component.types.includes('locality'))?.long_name;
    const state = address_components?.find((component) => component.types.includes('administrative_area_level_1'))?.long_name;
    const address_zip = address_components?.find((component) => component.types.includes('postal_code'))?.long_name;
    return {
        name,
        address_first,
        address_city,
        state,
        address_zip,
    };
};
exports.getUsableAddressComponentsFromPlaceDetails = getUsableAddressComponentsFromPlaceDetails;
